import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["name", "value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("input", {
        type: "hidden",
        name: _ctx.dataMember,
        value: _ctx.modelValue
    }, null, 8, _hoisted_1));
}
